import {
  Backdrop,
  Box,
  Button,
  Dialog,
  Fade,
  Stack,
  Typography,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

export default function DeleteMessageModal({
  open,
  onClose,
  onConfirm,
  messageTitle = "Mensaje",
}) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          borderRadius: "30px",
          overflow: "visible",
        },
      }}
      slotProps={{
        backdrop: {
          timeout: 180,
          sx: { bgcolor: "rgba(2, 8, 23, 0.45)", backdropFilter: "blur(3px)" },
        },
      }}
    >
      <Fade in={!!open} timeout={180}>
        <Box
          sx={{
            bgcolor: "neutral.500",
            borderRadius: "30px",
            p: { xs: 2, sm: 3 },
            boxShadow: "0px 20px 60px rgba(0,0,0,.28)",
            width: "min(90vw, 460px)",
          }}
        >
          <Stack spacing={2.25} sx={{ width: "100%", alignItems: "center" }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                px: "22px",
                py: "10px",
                bgcolor: "secondary.50",
                borderRadius: "33px",
                boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
              }}
            >
              <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "primary.900", lineHeight: 1 }}>
                Confirmar eliminación
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                bgcolor: "rgba(247, 247, 248, 1)",
                borderRadius: "20px",
                boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.5)",
                p: 2,
              }}
            >
              <Typography sx={{ fontSize: "15px", fontWeight: 500, color: "primary.900", lineHeight: 1.35 }}>
                ¿Estás seguro de que deseas eliminar el mensaje "{messageTitle}"?
              </Typography>

              <Typography
                sx={{
                  mt: 1.2,
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "primary.800",
                  opacity: 0.72,
                }}
              >
                Esta acción no se puede deshacer.
              </Typography>
            </Box>

            <Stack
              direction="row"
              spacing={1.5}
              sx={{
                width: "100%",
                justifyContent: "flex-end",
                flexWrap: "wrap",
              }}
            >
              <Button
                variant="contained"
                startIcon={<CloseIcon sx={{ fontSize: 18 }} />}
                onClick={onClose}
                disabled={isDeleting}
                sx={{
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 800,
                  borderRadius: "33px",
                  px: 2.5,
                  minHeight: 40,
                  bgcolor: "secondary.50",
                  color: "primary.900",
                  boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
                  "&:hover": {
                    bgcolor: "secondary.100",
                    boxShadow: "inset 0px 0px 4px rgba(117, 117, 138, 0.5)",
                  },
                }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                startIcon={<DeleteOutlineIcon sx={{ fontSize: 18 }} />}
                onClick={handleConfirm}
                disabled={isDeleting}
                sx={{
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 800,
                  borderRadius: "33px",
                  px: 2.5,
                  minHeight: 40,
                  bgcolor: "error.main",
                  color: "white",
                  boxShadow: "0px 8px 20px rgba(211, 47, 47, 0.28)",
                  "&:hover": {
                    bgcolor: "error.dark",
                    boxShadow: "0px 10px 24px rgba(211, 47, 47, 0.32)",
                  },
                  "&:disabled": {
                    bgcolor: "error.light",
                    color: "rgba(255, 255, 255, 0.6)",
                  },
                }}
              >
                {isDeleting ? "Eliminando..." : "Eliminar"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Dialog>
  );
}
